<template>
  <div>
    <v-card>
      <v-card-title>Résultats de la recherche</v-card-title>
      <v-card-text>
        <base-data-table
          :items="resultItems"
          :serverItemsLength="clientPortals.total"
          :nbItemsByPage="NB_ITEMS_BY_PAGE"
          :loading="isLoading"
          :options.sync="options"
          :headers="headers"
          itemClickRouterTarget="portail-details"
          class="table-cursor"
          containerId="#search-table-portails-container"
        ></base-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import router from "@/router";
import { onMounted, ref, toRefs, watch } from "@vue/composition-api";
import { useGlobalSearch } from "../composables/global-search";
import { useClientPortal } from "../composables/client-portal";
import { useTitle } from "../composables/title";
import BaseDataTable from "@/components/General/BaseDataTable.vue";

export default {
  components: {
    BaseDataTable,
  },
  setup() {
    /* Import des API */
    const { globalSearchResult } = useGlobalSearch();
    const {
      data,
      listClientPortals,
      criteriaClientPortal,
      resetClientPortalCriteria,
    } = useClientPortal();
    const { setIcon, setTitle } = useTitle();

    /* Variables */
    const searchType = router.currentRoute.params.type;
    const searchTerm = router.currentRoute.params.term;
    let headers = ref([]);
    const resultItems = ref(globalSearchResult.value);
    const NB_ITEMS_BY_PAGE = 10;

    /* Méthodes */
    const assignHeaders = function () {
      switch (searchType) {
        default:
          headers.value = [
            { text: "Passman ID", value: "passmanId" },
            { text: "ID Externe", value: "reference" },
            { text: "Description", value: "description" },
          ];
      }
    };
    const fetchPortals = async function () {
      data.isLoading = true;
      await listClientPortals();
      resultItems.value = data.clientPortals.data;
      data.isLoading = false;
    };
    const checkSearchTermType = function () {
      // On ràz les filtres des portails avant de continuer
      resetClientPortalCriteria();
      // Si le terme de la recherche est un nombre, on l'assigne au critère de recherche passmanId (recherche exacte)
      if (!isNaN(parseInt(searchTerm))) {
        criteriaClientPortal.value.passmanId = searchTerm;
      } else {
        // Sinon on l'assigne au champ description
        criteriaClientPortal.value.description = searchTerm;
      }
    };

    /* Watchers */
    watch(
      () => data.options,
      async (newValue, oldValue) => {
        if (oldValue.page !== undefined) {
          fetchPortals();
        }
      },
      {
        deep: true,
      }
    );

    /* Cycle de vie */
    onMounted(() => {
      checkSearchTermType();
      assignHeaders();
      setTitle("");
      setIcon("");
      fetchPortals();
    });

    return {
      searchType,
      headers,
      searchTerm,
      resultItems,
      NB_ITEMS_BY_PAGE,
      ...toRefs(data),
    };
  },
};
</script>
